import { useTheme } from "styled-components";
import { IThemeBreakpoints } from "../types/theme";
import _get from "lodash/get";
import { useEffect, useState } from "react";

export const useMediaQuery = (
  device: keyof IThemeBreakpoints,
  defaultValue?: boolean
) => {
  const [matches, setMatches] = useState<boolean>(
    defaultValue !== undefined ? defaultValue : false
  );
  const theme = useTheme();
  const breakpoint = _get(theme, `breakpoints.${device}`);

  useEffect(() => {
    if (!breakpoint) return;

    const mql = window.matchMedia(`(min-width: ${breakpoint})`);
    setMatches(mql.matches);

    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [breakpoint]);

  return matches;
};
